import { render } from "./IdNumberInput.html?vue&type=template&id=71645d5d&external"
import script from "./IdNumberInput.js?vue&type=script&lang=js&external"
export * from "./IdNumberInput.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__